import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usePaginationQuery } from "../../utils/hooks/use-pagination-query";
import { http } from "../../utils";

async function fetchTaxInvoices() {
  return await http("/admin/tax-invoices/eligible");
}

export function useTaxInvoices() {
  return usePaginationQuery(["tax-invoices"], fetchTaxInvoices);
}

async function markTaxInvoiceIssued(payload) {
  return await http("/admin/tax-invoices/mark-issued", {
    data: payload,
  });
}

export function useMarkTaxInvoiceIssued() {
  const queryClient = useQueryClient();

  return useMutation(markTaxInvoiceIssued, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(["tax-invoices"]);
    },
  });
}
